import React, { useContext, useState, useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { setKeycloak } from "../services/api";

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {

    const [userAuth, setUserAuth] = useState();
    const [userMenu, setUserMenu] = useState();
    const [userNotification, setUserNotification] = useState([]);

    const [ativo, setAtivo] = useState({
        tagNum: '',
        tagDesc: '',
        tagID: 0,
        ativoID: 0,
        status: '',
        fabricante: '',
        modelo: '',
        ativo: false,
        tipoAtivo: '',
        numeroSerie: '',
    });

    const { keycloak } = useKeycloak();
    const authenticated = keycloak?.authenticated;

    useEffect(() => {
        if (!keycloak) return;

        setKeycloak(keycloak);

        if (authenticated && keycloak.token) {

            setUserAuth({
                nome: keycloak.idTokenParsed?.given_name,
                sobrenome: keycloak.idTokenParsed?.family_name,
                email: keycloak.idTokenParsed?.email,
                perfilID: null,
                userID: keycloak.idTokenParsed?.userIDAttr,
                refreshToken: keycloak.refreshToken,
                token: keycloak.token,
                clientID: keycloak.idTokenParsed?.clientIDAttr,
                reloadMenu: false,
                accessToken: {
                    headers: {
                        Authorization: 'Bearer ' + keycloak.token
                    }
                }
            });
        }

    }, [authenticated, keycloak]);

    return (
        <AuthContext.Provider
            value={{
                userAuth,
                setUserAuth,
                userMenu,
                setUserMenu,
                ativo,
                setAtivo,
                userNotification,
                setUserNotification
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export function useAuth() {
    return useContext(AuthContext);
}

export function useAtivo() {
    const context = useContext(AuthContext);

    return {
        ativo: context.ativo,
        setAtivo: context.setAtivo
    };
}

export function useNotification() {
    const context = useContext(AuthContext);

    return {
        userNotification: context.userNotification,
        setUserNotification: context.setUserNotification
    };
}